import { ReactElement } from 'react'
import { useSetAtom } from 'jotai'
import { modalStatusAtom } from 'store/atoms'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FAR_PLUS_CIRCLE } from 'const/icons'
import i18n from 'strings/i18n'

import {
  AddAccountButtonIconWrapper,
  AddAccountButtonStyle,
  AddAccountButtonWrapper,
  AddAccountTextWrapper
} from './subcomponents'

const AddAccountButton = (): ReactElement => {
  const updateModalStatus = useSetAtom(modalStatusAtom)

  const addAccountHandler = () => {
    updateModalStatus('AddAccount', 'add-account-container-id')
  }
  return (
    <AddAccountButtonStyle
      buttonType="secondary"
      dataCy="add-account-button"
      data-test="add-account-button"
      onClick={addAccountHandler}
      data-type="dashboard"
      data-reason="add synchrony account to manager"
      data-object="button"
      data-analytics="clicktrackingevent"
    >
      <AddAccountButtonWrapper>
        <AddAccountButtonIconWrapper>
          <FontAwesomeIcon icon={FAR_PLUS_CIRCLE} />
        </AddAccountButtonIconWrapper>
        <AddAccountTextWrapper>
          {i18n({ button: 'addAccount' })}
        </AddAccountTextWrapper>
      </AddAccountButtonWrapper>
    </AddAccountButtonStyle>
  )
}

export default AddAccountButton
